import React from 'react';

import { type MessageDescriptor, useIntl } from 'react-intl-next';

import { ButtonItem, MenuGroup, Section } from '@atlaskit/menu';

export type AudioFeatureMenuItem = {
	label: MessageDescriptor;
	onClick: () => void;
	icon?: React.ReactNode;
	isDisabled?: boolean;
	testId?: string;
	title: MessageDescriptor;
	description?: string;
	renderPanel?: {
		header: string;
		body: React.ReactNode;
		onBackClick?: () => void;
	};
};

type AudioFeatureMenuGroupProps = {
	items: AudioFeatureMenuItem[];
};

export const AudioFeatureMenuGroup = ({ items }: AudioFeatureMenuGroupProps) => {
	const { formatMessage } = useIntl();
	return (
		<MenuGroup testId="audio-object-menu-group">
			<Section>
				{items.map((item) => (
					<ButtonItem
						iconBefore={item.icon}
						key={formatMessage(item.label)}
						onClick={item.onClick}
						isDisabled={item.isDisabled}
						testId={item.testId}
						description={item.description}
					>
						<div>{formatMessage(item.title)}</div>
					</ButtonItem>
				))}
			</Section>
		</MenuGroup>
	);
};
